<template>
    <div>
        <v-card>
            <v-card-title class="blue_corp white--text" style="height: 50px;">
                <span class="mt-n2">SOLICITUD</span>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="8" md="2" class="form-space">
                                <v-text-field v-model="sku" label="SKU" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="4" md="1" class="form-space">
                                <v-btn class="mt-2" @click="inventa=true" small color="indigo" dark rounded>
                                    <v-icon small>find_replace</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="4" class="form-space">
                                <v-text-field v-model="nombre" label="Nombre Producto" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2" class="form-space">
                                <v-text-field v-model="universal" label="Cod.Universal" outlined dense disabled filled></v-text-field>
                                <!-- <v-select class='text-caption' v-model="universal" :items="itemUniversal" item-text="codigo" label="Cod.Universal" dense outlined></v-select> -->
                            </v-col>
                            <v-col cols="8" md="2" class="form-space">
                                <v-text-field @keypress="onlyNumber" v-model="cantidad" label="Cantidad" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="4" md="1" class="form-space">
                                <v-btn class="ml-2 mt-1" @click="addItem()" fab x-small dark color="indigo"><v-icon>add</v-icon></v-btn>
                            </v-col>
                            <v-col cols="12" md="12" class="form-space">
                                <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="mt-n5">
                                        <v-data-table dense dark fixed-header height="230" 
                                            :headers="detalle_head" 
                                            :items="detalle_items" 
                                            :page.sync="page" 
                                            :items-per-page="itemsPerPage" 
                                            hide-default-footer 
                                            class="elevation-1 text-size" 
                                            @page-count="pageCount = $event">
                                            <template v-slot:item.accion="{ item }">
                                                <v-icon @click="deleteItem(item.id)" small>delete</v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>                                
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions style="margin-top:-25px">
                <v-row>
                    <v-col cols="12" md="5">
                        <v-row>
                            <v-col cols="12" md="3"></v-col>
                            <v-col cols="12" md="5" class="text-right">
                                <v-text-field v-model="alias" label="Alias" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date1" label="Fecha" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12" md="4" class="text-end">
                                <v-btn @click="search_solicitud()" class="mt-1" x-small color="info" dark fab><v-icon>edit</v-icon></v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="numero" label="Numero Solicitud" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-2">
                                <v-btn @click="clsInput()" class="ml-2" small color="teal" dark rounded block><v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span></v-btn>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-2">
                                <div v-if="div_btn=='save'">
                                    <v-btn v-if="btn_grabar==true" @click="save_solicitud()" class="ml-2" small color="teal" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn>                
                                    <v-btn v-else class="ml-2" small color="grey" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn>
                                </div>
                                <div v-if="div_btn=='update'">
                                    <v-btn v-if="btn_modifica==true" @click="update_solicitud()" class="ml-2" small color="teal" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Modificar</span></v-btn>                
                                    <v-btn v-else class="ml-2" small color="grey" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Modificar</span></v-btn>
                                </div>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-1">
                                <v-btn v-if="btn_print==true" class="ml-2" icon><v-icon color="teal">print</v-icon></v-btn>
                                <v-btn v-else class="ml-2" icon><v-icon color="grey">print</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

        <!-- dialog inventa --> 
        <v-dialog v-model="inventa" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="inventa=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleProductos" dense dark :search="inventasearch" :headers="inventatitulo" 
                        :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  
                        @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- dialog Solicitudes --> 
        <v-dialog v-model="solicita" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="solicita=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="solicitasearch" label="Buscar Producto" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleSolicita" dense dark :search="solicitasearch" :headers="solicitatitulo" 
                        :items="solicitalista" :page.sync="solicitapage" :items-per-page="solicitaitemsPerPage"  
                        @page-count="solicitapageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"/>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 33px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
.form-space {
    margin-top:-20px;
}
</style>
<script>
import axios from 'axios';
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
export default {
    name:'Solicita', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            sku:'',
            nombre:'',
            universal:'',
            cantidad:'',
            numero:0,
            alias:'',
            menu1:false,
            date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            idItems:0,
            //detalle solicitud
            page: 1,
            pageCount: 0,
            itemsPerPage: 1000000,
            detalle_head:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                { text: 'Cod. Universal', align: 'center', sortable: true, value: 'universal' },
                { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad' },
                { text: 'Accion', align: 'center', sortable: true, value: 'accion' },
            ],
            detalle_items:[],
            //lista productos
            inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku', width:'' },
                { text: 'Cod. Barra', align: 'start', sortable: true, value: 'barraSku' },
                { text: 'Cod. Universal', align: 'start', sortable: true, value: 'universalSku' },
                { text: 'Producto', align: 'start', sortable: true, value: 'nameSku' },
                { text: 'Medida', align: 'start', sortable: true, value: 'medidaSku' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 1000000,
            //lista solicitudes
            solicita:false,
            solicitasearch:'',
            solicitatitulo:[
                { text: 'Fecha', align: 'start', sortable: true, value: 'fecha', width:'' },
                { text: 'Numero', align: 'start', sortable: true, value: 'numero' },
                { text: 'Alias', align: 'start', sortable: true, value: 'alias' },
            ],
            array_solicitud:[],
            solicitalista:[],
            solicitapage: 1,
            solicitapageCount: 0,
            solicitaitemsPerPage: 10,
            div_btn:'save',
            btn_grabar:true,
            btn_modifica:true,
            btn_print:false,
        }
    },
    async mounted(){

        await this.buscarProducto();
    },
    methods:{
        clsInput(){
            this.detalle_items=[];
            this.numero=0;
            this.alias='';
            this.clsproducts();
            this.div_btn='save';
            this.btn_grabar=true;
            this.btn_modifica=true;
            this.btn_print=false;
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        }, 
        clsproducts(){
            this.sku='';
            this.nombre='';
            this.universal='';
            this.cantidad='';
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async buscarProducto(){
            this.loading=true;
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
                const datos=response.data;
                this.inventalista=[];
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.inventalista.push({
                            sku:element.Sku,
                            barraSku:element.Barra,
                            universalSku:element.Universal,
                            nameSku:element.Nombre,
                            medidaSku:element.Medida
                        });                    
                    });
                }                
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        handleProductos(fila) {
            //buscamos sku en la lista
            this.sku = fila.sku;
            this.nombre = fila.nameSku;
            this.universal = fila.universalSku;
            this.inventa=false;
        },
        addItem(){
            if(this.sku.trim()!='' && this.cantidad!='' && this.universal!=''){
                this.idItems++
                this.detalle_items.push({
                    'id':this.idItems,
                    'sku': this.sku,
                    'universal': this.universal,
                    'producto':this.nombre,
                    'cantidad':this.cantidad,
                });
                this.clsproducts();
            } else {
                this.Msg='Datos Obligatorios'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
        },
        deleteItem(n){
            this.detalle_items = this.detalle_items.filter(function(dat) {
                return dat.id !== n; 
            });
        },
        async save_solicitud(){
            this.loading=true;       
            try {
                if(this.detalle_items.length!=0 && this.alias!='' && this.alias!=null){
                    //crear numero de solicitud
                    let numero_solicitud = 0;
                    const par_number = { 
                        'contrato': this.contrato,
                        'usuario': this.usu,
                    };
                    const res_number = await axios.post(process.env.VUE_APP_URL + '/api/inv/numero/solicitud/', par_number);
                    const data_number=res_number.data;
                    if (data_number=='si'){
                        //obtener el numero creado
                        const get_estado = 'N';
                        const par_get = this.contrato + '/' + this.usu + '/' + get_estado; 
                        const get_number = await axios.get(process.env.VUE_APP_URL + '/api/inv/numero/solicitud/' + par_get);
                        const data_get_number=get_number.data;
                        if (data_get_number[0].existe=='si'){
                            //obtener el numero creado
                            numero_solicitud = data_get_number[0].ID;
                        }
                    };
                    let total_save = 0;
                    if(parseInt(numero_solicitud)!=0){
                        for (let index = 0; index < this.detalle_items.length; index++) {
                            const element = this.detalle_items[index];
                            const params={
                                'contrato': this.contrato,
                                'numero': numero_solicitud,
                                'sku': element.sku,
                                'universal':element.universal,
                                'cantidad':element.cantidad,
                                'estado':'V',
                                'usuario':this.usu,
                                'fecha': this.date1,
                                'alias': this.alias
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/solicitud/',params);
                            const datos=response.data;
                            if (datos=='si'){
                                total_save = parseInt(total_save) + 1;
                            }
                        }
                    } else {
                        this.Msg='No es posible generar una nueva solicitud'
                        this.color='red';
                        this.msgbox=true;
                        this.showSnack();
                    }
                    if(parseInt(total_save)!=0){
                        const params={
                            'contrato': this.contrato,
                            'usuario':this.usu,
                            'estado': 'V'
                        };
                        const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/numero/solicitud/'+ numero_solicitud,params);
                        const datos=response.data;
                        if (datos=='si'){
                            this.numero = numero_solicitud
                            this.Msg='Solicitud generada con exito'
                            this.color='success';
                            this.msgbox=true;
                            this.showSnack();
                            this.btn_grabar=false;
                            this.btn_print=true;
                        }
                    }
                } else {
                    this.Msg='No existen datos en la lista'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } catch (error) {
               console.log(error) 
            }
            this.loading=false;
        },
        async search_solicitud(){
            this.loading=true;
            this.array_solicitud=[];
            this.solicitalista=[];
            try {
                const get_number = 'all';
                const par_get = this.contrato + '/' + get_number; 
                const res_number = await axios.get(process.env.VUE_APP_URL + '/api/inv/solicitud/' + par_get);
                const data_number=res_number.data;
                if (data_number[0].existe=='si'){
                    this.array_solicitud = data_number;
                    let myNumber = 0;
                    this.array_solicitud.forEach(element => {
                        if(parseFloat(myNumber)!=parseFloat(element.Numero)){
                            this.solicitalista.push({
                                'fecha': element.Fecha,
                                'numero': element.Numero,
                                'alias': element.Alias
                            })
                        }
                        myNumber = element.Numero;
                    });
                }
                this.solicita=true;
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async handleSolicita(fila) {
            this.clsInput();
            const filter = this.array_solicitud.filter(res => parseFloat(res.Numero) == parseFloat(fila.numero));
            if(filter.length!=0){
                filter.forEach(element => {
                    this.detalle_items.push({
                        'id': element.ID,
                        'sku': element.Sku,
                        'universal': element.Universal,
                        'producto': element.Producto,
                        'cantidad': element.Cantidad,
                    });
                });
                this.numero = filter[0].Numero;
                this.date1 = filter[0].Fecha;
                this.alias = filter[0].Alias;
            }
            this.div_btn='update';
            this.solicita=false;
        },
        async update_solicitud(){
            this.loading=true;
            try {
                if(this.detalle_items.length!=0 && this.alias!='' && this.alias!=null && parseFloat(this.numero)!=0){
                    //eliminamos la solicitud
                    const par_del = this.contrato + '/' + this.numero; 
                    const res_del = await axios.delete(process.env.VUE_APP_URL + '/api/inv/solicitud/' + par_del);
                    const data_del=res_del.data;
                    if(data_del=='si'){
                        //grabar la nueva solicitud
                        let total_save = 0;
                        for (let index = 0; index < this.detalle_items.length; index++) {
                            const element = this.detalle_items[index];
                            const params={
                                'contrato': this.contrato,
                                'numero': this.numero,
                                'sku': element.sku,
                                'universal': element.universal,
                                'cantidad': element.cantidad,
                                'estado': 'V',
                                'usuario': this.usu,
                                'fecha': this.date1,
                                'alias': this.alias
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/solicitud/',params);
                            const datos=response.data;
                            if (datos=='si'){
                                total_save = parseInt(total_save) + 1;
                            }
                        };
                        if(parseFloat(total_save)!=0){
                            this.Msg='La solicitud se ha modificado con exito'
                            this.color='success';
                            this.msgbox=true;
                            this.showSnack();
                            this.btn_modifica=false;
                            this.btn_print=true;
                        } else {
                            this.Msg='Datos corruptos, ya no existen registros de esta solicitud'
                            this.color='red';
                            this.msgbox=true;
                            this.showSnack();                               
                        }
                    } else {
                        this.Msg='No es posible modificar la solicitud'
                        this.color='red';
                        this.msgbox=true;
                        this.showSnack();
                    }
                } else {
                    this.Msg='Faltan datos para modificar la solicitud'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        }

    }

}
</script>